// import React from 'react';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';

const Layout = () => {
  useEffect(() => {
    const preventZoomScroll = (e: WheelEvent) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };

    const preventZoomKeys = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && ['=', '-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    };

    window.addEventListener('wheel', preventZoomScroll, { passive: false });
    window.addEventListener('keydown', preventZoomKeys);

    return () => {
      window.removeEventListener('wheel', preventZoomScroll);
      window.removeEventListener('keydown', preventZoomKeys);
    };
  }, []);

  
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
};

export default Layout;